export const rights: [number, number][] = [
  [2.5911055472340543, -4.159029265298354],
  [2.191105928703781, -3.759029646768081],
  [2.391104784294601, -3.1590292652983543],
  [1.7911044028248746, -3.3590300282378074],
  [1.4911051657643277, -3.959030409707534],
  [1.9911051657643277, -4.359030028237807],
  [1.3911047842946012, -4.659029265298354],
  [0.8911047842946012, -4.959030409707534],
  [0.8911047842946012, -4.259029646768081],
  [1.1911059287037808, -3.459030409707534],
  [0.7911044028248746, -2.959030409707534],
  [1.3911047842946012, -2.8590300282378074],
  [1.0911055472340543, -2.259029646768081],
  [0.4911051657643277, -2.3590300282378074],
  [-0.008894834235672278, -1.7590296467680808],
  [0.6911059287037808, -1.5590288838286277],
  [1.2911044028248746, -1.2590296467680808],
  [1.3911047842946012, -0.45903040970753395],
  [0.6911059287037808, -0.7590296467680808],
  [-0.008894834235672278, -0.959030409707534],
  [0.09110554723405428, -0.2590296467680808],
  [-0.4088944527659457, 0.04096959029246605],
  [0.6911059287037808, 0.04096959029246605],
  [0.7911044028248746, 0.7409703532319192],
  [0.09110554723405428, 0.540969590292466],
  [-0.5088948342356723, 1.1409699717621926],
  [-0.8088940712962192, 0.540969590292466],
  [-1.2088955971751254, 1.040969590292466],
  [-1.9088944527659457, 1.040969590292466],
  [-2.4088944527659457, 1.540969590292466],
  [-2.808894071296219, 2.1409699717621926],
  [-2.5088948342356723, 2.8409707347016457],
  [-3.0088948342356723, 3.3409707347016457],
  [-3.7088955971751254, 3.3409707347016457],
  [-3.608895215705399, 3.9409711161713723],
  [-2.7088955971751254, 4.540969590292466],
  [-3.308894071296219, 5.040969590292466],
  [-3.2088955971751254, 5.940971116171372],
  [-2.308894071296219, 5.640969971762193],
  [-2.5088948342356723, 6.740970353231919],
  [-1.7088955971751254, 6.840970734701646],
  [-2.2088955971751254, 7.740970353231919],
  [-1.3088940712962192, 7.940971116171372],
  [-0.9088944527659457, 8.840970734701646],
  [-1.7088955971751254, 9.24097035323192],
  [-1.7088955971751254, 10.040969590292466],
  [-2.4088944527659457, 9.840970734701646],
  [-2.608895215705399, 9.040969590292466],
  [-2.0088948342356723, 8.540969590292466],
  [-2.7088955971751254, 8.340970734701646],
  [-2.9088944527659457, 7.540969590292466],
  [-3.2088955971751254, 6.740970353231919],
  [-4.908894452765946, 6.940971116171372],
  [-5.108895215705399, 7.540969590292466],
  [-5.308894071296219, 8.140969971762193],
  [-5.808894071296219, 8.540969590292466],
  [-6.308894071296219, 8.940971116171372],
  [-6.908894452765946, 9.24097035323192],
  [-7.108895215705399, 8.640969971762193],
  [-7.308894071296219, 8.040969590292466],
  [-7.808894071296219, 8.540969590292466],
  [-7.608895215705399, 9.24097035323192],
  [-8.208895597175125, 9.24097035323192],
  [-8.908894452765946, 9.040969590292466],
  [-10.008894834235672, 10.640969971762193],
  [-9.808895024970536, 11.140969971762193],
  [-10.308895024970536, 11.24097035323192],
  [-10.708894643500809, 10.640969971762193],
  [-10.908894452765946, 11.040969590292466],
  [-12.008894834235672, 10.940971116171372],
  [-12.308895024970536, 11.440970162497056],
  [-11.808895024970536, 11.640969971762193],
  [-11.508894834235672, 11.940970162497056],
  [-11.308895024970536, 12.440970162497056],
  [-11.008894834235672, 12.840970734701646],
  [-11.408894452765946, 13.040970543966782],
  [-11.908894452765946, 12.74097035323192],
  [-12.108895215705399, 12.24097035323192],
  [-12.908894452765946, 12.340970734701646],
  [-12.508894834235672, 11.940970162497056],
  [-12.908894452765946, 10.74097035323192],
  [-13.508894834235672, 10.74097035323192],
  [-13.308895024970536, 10.24097035323192],
  [-12.708894643500809, 10.040969590292466],
  [-12.408894452765946, 10.540969590292466],
  [-12.108895215705399, 9.840970734701646],
  [-11.808895024970536, 10.440971116171372],
  [-11.308895024970536, 10.540969590292466],
  [-10.408894452765946, 10.24097035323192],
  [-10.908894452765946, 9.940971116171372],
  [-11.508894834235672, 9.840970734701646],
  [-11.708894643500809, 9.24097035323192],
  [-11.608895215705399, 8.640969971762193],
  [-11.608895215705399, 8.040969590292466],
  [-11.008894834235672, 7.740970353231919],
  [-10.408894452765946, 7.640969971762193],
  [-9.908894452765946, 8.040969590292466],
  [-9.508894834235672, 8.640969971762193],
  [-8.608895215705399, 8.340970734701646],
  [-8.008894834235672, 7.840970734701646],
  [-8.108895215705399, 7.140969971762193],
  [-8.908894452765946, 7.640969971762193],
  [-8.80889407129622, 6.740970353231919],
  [-8.708895597175125, 5.840970734701646],
  [-8.008894834235672, 6.340970734701646],
  [-7.808894071296219, 5.540969590292466],
  [-7.308894071296219, 5.940971116171372],
  [-7.408894452765946, 6.640969971762193],
  [-7.408894452765946, 7.340970734701646],
  [-6.808894071296219, 7.040969590292466],
  [-6.708895597175125, 7.740970353231919],
  [-6.508894834235672, 8.24097035323192],
  [-5.908894452765946, 7.840970734701646],
  [-6.208895597175125, 7.240970353231919],
  [-5.608895215705399, 7.140969971762193],
  [-6.108895215705399, 6.640969971762193],
  [-6.708895597175125, 6.340970734701646],
  [-6.608895215705399, 5.740970353231919],
  [-7.108895215705399, 5.240970353231919],
  [-6.708895597175125, 4.640969971762193],
  [-7.208895597175125, 4.040969590292466],
  [-7.508894834235672, 4.740970353231919],
  [-8.30889407129622, 4.840970734701646],
  [-9.208894643500809, 5.140969971762193],
  [-10.108895215705399, 5.340970734701646],
  [-10.508894834235672, 6.140969971762193],
  [-9.608895215705399, 6.240970353231919],
  [-9.708894643500809, 7.140969971762193],
  [-10.508894834235672, 6.940971116171372],
  [-11.008894834235672, 6.540969590292466],
  [-11.208894643500809, 7.140969971762193],
  [-11.808895024970536, 7.440971116171372],
  [-11.808895024970536, 6.640969971762193],
  [-12.008894834235672, 5.840970734701646],
  [-12.208894643500809, 5.140969971762193],
  [-12.608895215705399, 4.440971116171372],
  [-13.008894834235672, 3.740970353231919],
  [-13.508894834235672, 3.1409699717621926],
  [-9.708894643500809, 1.4409711161713723],
  [-8.80889407129622, 2.1409699717621926],
  [-9.608895215705399, 2.540969590292466],
  [-9.708894643500809, 3.4409711161713723],
  [-9.808895024970536, 4.340970734701646],
  [-8.908894452765946, 4.140969971762193],
  [-8.008894834235672, 4.040969590292466],
  [-8.608895215705399, 3.240970353231919],
  [-8.008894834235672, 2.540969590292466],
  [-8.208895597175125, 1.7409703532319192],
  [-7.808894071296219, 1.1409699717621926],
  [-7.308894071296219, 0.6409699717621926],
  [-8.108895215705399, 0.34097073470164574],
  [-8.80889407129622, 1.040969590292466],
  [-9.808895024970536, 0.4409711161713723],
  [-8.908894452765946, -0.0590288838286277],
  [-8.108895215705399, -0.45903040970753395],
  [-7.408894452765946, -0.15902926529835426],
  [-7.408894452765946, -0.8590300282378074],
  [-8.008894834235672, -1.3590300282378074],
  [-8.908894452765946, -1.0590288838286277],
  [-9.808895024970536, -0.6590292652983543],
  [-9.808895024970536, -1.7590296467680808],
  [-8.80889407129622, -2.0590288838286277],
  [-8.008894834235672, -2.1590292652983543],
  [-7.208895597175125, -2.459030409707534],
  [-7.308894071296219, -1.6590292652983543],
  [-6.708895597175125, -1.2590296467680808],
  [-6.708895597175125, -0.45903040970753395],
  [-6.108895215705399, -0.8590300282378074],
  [-5.808894071296219, -0.2590296467680808],
  [-6.208895597175125, 0.24097035323191918],
  [-6.808894071296219, 0.24097035323191918],
  [-6.608895215705399, 0.8409707347016457],
  [-7.008894834235672, 1.3409707347016457],
  [-7.508894834235672, 1.9409711161713723],
  [-6.708895597175125, 2.040969590292466],
  [-6.308894071296219, 1.540969590292466],
  [-5.608895215705399, 1.540969590292466],
  [-6.008894834235672, 2.1409699717621926],
  [-5.808894071296219, 2.740970353231919],
  [-6.508894834235672, 2.740970353231919],
  [-7.208895597175125, 2.6409699717621926],
  [-7.708895597175125, 3.240970353231919],
  [-6.908894452765946, 3.3409707347016457],
  [-6.108895215705399, 3.3409707347016457],
  [-5.408894452765946, 3.3409707347016457],
  [-5.008894834235672, 3.8409707347016457],
  [-5.708895597175125, 3.9409711161713723],
  [-6.408894452765946, 4.040969590292466],
  [-6.008894834235672, 4.540969590292466],
  [-5.408894452765946, 4.440971116171372],
  [-5.008894834235672, 5.040969590292466],
  [-5.708895597175125, 5.240970353231919],
  [-6.308894071296219, 5.240970353231919],
  [-6.008894834235672, 5.940971116171372],
  [-5.508894834235672, 6.440971116171372],
  [-4.808894071296219, 6.240970353231919],
  [-5.308894071296219, 5.740970353231919],
  [-4.708895597175125, 5.540969590292466],
  [-4.408894452765946, 4.940971116171372],
  [-4.708895597175125, 4.340970734701646],
  [-4.108895215705399, 4.340970734701646],
  [-4.308894071296219, 3.6409699717621926],
  [-4.808894071296219, 3.1409699717621926],
  [-4.208895597175125, 2.9409711161713723],
  [-3.5088948342356723, 2.6409699717621926],
  [-4.108895215705399, 2.240970353231919],
  [-4.708895597175125, 2.4409711161713723],
  [-5.208895597175125, 2.6409699717621926],
  [-5.208895597175125, 2.040969590292466],
  [-4.708895597175125, 1.7409703532319192],
  [-5.108895215705399, 1.1409699717621926],
  [-5.908894452765946, 0.9409711161713723],
  [-5.408894452765946, 0.4409711161713723],
  [-5.108895215705399, -0.15902926529835426],
  [-4.708895597175125, -0.6590292652983543],
  [-4.408894452765946, -1.2590296467680808],
  [-4.108895215705399, -1.8590300282378074],
  [-3.7088955971751254, -2.5590288838286277],
  [-4.408894452765946, -2.5590288838286277],
  [-4.808894071296219, -1.959030409707534],
  [-5.108895215705399, -1.3590300282378074],
  [-5.508894834235672, -0.7590296467680808],
  [-5.908894452765946, -1.459030409707534],
  [-6.508894834235672, -1.959030409707534],
  [-6.608895215705399, -2.759029646768081],
  [-6.508894834235672, -3.759029646768081],
  [-7.108895215705399, -3.259029646768081],
  [-7.808894071296219, -3.0590288838286277],
  [-8.708895597175125, -3.0590288838286277],
  [-9.608895215705399, -2.8590300282378074],
  [-9.108895215705399, -4.059028883828628],
  [-8.108895215705399, -4.059028883828628],
  [-8.508894834235672, -5.059028883828628],
  [-7.808894071296219, -5.959030409707534],
  [-6.808894071296219, -5.759029646768081],
  [-6.008894834235672, -5.359028120889175],
  [-7.408894452765946, -4.959030409707534],
  [-7.208895597175125, -4.159029265298354],
  [-6.508894834235672, -4.659029265298354],
  [-5.608895215705399, -4.659029265298354],
  [-5.808894071296219, -3.959030409707534],
  [-6.108895215705399, -3.259029646768081],
  [-5.908894452765946, -2.5590288838286277],
  [-5.508894834235672, -1.959030409707534],
  [-5.108895215705399, -2.5590288838286277],
  [-5.408894452765946, -3.259029646768081],
  [-4.708895597175125, -3.259029646768081],
  [-4.408894452765946, -3.8590300282378074],
  [-5.108895215705399, -3.959030409707534],
  [-4.808894071296219, -4.659029265298354],
  [-4.008894834235672, -4.459030409707534],
  [-4.408894452765946, -5.259029646768081],
  [-5.208895597175125, -5.459030409707534],
  [-4.708895597175125, -6.059028883828628],
  [-5.008894834235672, -6.959030409707534],
  [-5.808894071296219, -6.259029646768081],
  [-6.808894071296219, -6.859028120889175],
  [-5.908894452765946, -7.559028883828628],
  [-5.008894834235672, -8.059028883828628],
  [-4.208895597175125, -7.459030409707534],
  [-4.008894834235672, -6.659031172646987],
  [-3.808894071296219, -5.959030409707534],
  [-3.5088948342356723, -5.159031172646987],
  [-3.308894071296219, -4.459030409707534],
  [-2.608895215705399, -4.259029646768081],
  [-2.108895215705399, -3.959030409707534],
  [-1.5088948342356723, -3.6590292652983543],
  [-2.0088948342356723, -3.259029646768081],
  [-2.608895215705399, -3.459030409707534],
  [-3.108895215705399, -3.759029646768081],
  [-3.7088955971751254, -3.759029646768081],
  [-4.008894834235672, -3.1590292652983543],
  [-3.308894071296219, -3.0590288838286277],
  [-2.608895215705399, -2.8590300282378074],
  [-3.108895215705399, -2.459030409707534],
  [-2.9088944527659457, -1.7590296467680808],
  [-3.0088948342356723, -1.1590292652983543],
  [-3.5088948342356723, -1.8590300282378074],
  [-3.7088955971751254, -1.2590296467680808],
  [-3.4088944527659457, -0.6590292652983543],
  [-4.108895215705399, -0.6590292652983543],
  [-4.308894071296219, -0.0590288838286277],
  [-4.708895597175125, 0.4409711161713723],
  [-4.408894452765946, 1.040969590292466],
  [-4.008894834235672, 0.540969590292466],
  [-3.608895215705399, -0.0590288838286277],
  [-2.9088944527659457, -0.45903040970753395],
  [-2.9088944527659457, 0.24097035323191918],
  [-3.308894071296219, 0.6409699717621926],
  [-3.7088955971751254, 1.1409699717621926],
  [-4.108895215705399, 1.6409699717621926],
  [-3.5088948342356723, 1.9409711161713723],
  [-3.108895215705399, 1.4409711161713723],
  [-2.7088955971751254, 0.9409711161713723],
  [-2.2088955971751254, 0.4409711161713723],
  [-1.6088952157053988, 0.34097073470164574],
  [-2.2088955971751254, -0.15902926529835426],
  [-1.7088955971751254, -0.3590300282378074],
  [-1.1088952157053988, -0.15902926529835426],
  [-0.5088948342356723, -0.5590288838286277],
  [-0.6088952157053988, -1.2590296467680808],
  [-1.2088955971751254, -0.8590300282378074],
  [-1.8088940712962192, -1.1590292652983543],
  [-2.308894071296219, -0.7590296467680808],
  [-2.308894071296219, -1.459030409707534],
  [-1.8088940712962192, -1.8590300282378074],
  [-2.4088944527659457, -2.1590292652983543],
  [-1.9088944527659457, -2.5590288838286277],
  [-1.4088944527659457, -2.959030409707534],
  [-0.9088944527659457, -3.3590300282378074],
  [-0.4088944527659457, -3.0590288838286277],
  [-0.8088940712962192, -2.6590292652983543],
  [-1.3088940712962192, -2.259029646768081],
  [-1.2088955971751254, -1.5590288838286277],
  [-0.7088955971751254, -1.959030409707534],
  [-0.2088955971751254, -2.3590300282378074],
  [0.19110592870378085, -2.8590300282378074],
  [0.09110554723405428, -3.3590300282378074],
  [0.6911059287037808, -3.6590292652983543],
  [0.19110592870378085, -4.059028883828628],
  [0.2911044028248746, -4.659029265298354],
  [-0.4088944527659457, -3.759029646768081],
  [-0.4088944527659457, -4.359030028237807],
  [-0.30889407129621915, -5.059028883828628],
  [-1.0088948342356723, -4.759029646768081],
  [-1.0088948342356723, -4.059028883828628],
  [-1.5088948342356723, -4.359030028237807],
  [-2.108895215705399, -4.659029265298354],
  [-1.6088952157053988, -5.059028883828628],
  [-1.0088948342356723, -5.459030409707534],
  [-0.30889407129621915, -5.759029646768081],
  [0.2911044028248746, -6.059028883828628],
  [0.2911044028248746, -5.359028120889175],
  [0.8911047842946012, -5.659031172646987],
  [1.4911051657643277, -5.259029646768081],
  [1.9911051657643277, -5.059028883828628],
  [2.0911055472340543, -5.659031172646987],
  [1.4911051657643277, -5.959030409707534],
  [0.8911047842946012, -6.359028120889175],
  [0.2911044028248746, -6.759029646768081],
  [-0.4088944527659457, -6.559028883828628],
  [-1.0088948342356723, -6.159031172646987],
  [-1.6088952157053988, -5.859028120889175],
  [-2.2088955971751254, -5.459030409707534],
  [-2.808894071296219, -4.959030409707534],
  [-2.9088944527659457, -5.759029646768081],
  [-3.108895215705399, -6.659031172646987],
  [-2.308894071296219, -6.359028120889175],
  [-2.308894071296219, -7.359028120889175],
  [-3.308894071296219, -7.559028883828628],
  [-3.9088944527659457, -8.359028120889175],
  [-2.7088955971751254, -8.459030409707534],
  [-1.7088955971751254, -8.459030409707534],
  [-1.3088940712962192, -7.659031172646987],
  [-1.3088940712962192, -6.759029646768081],
  [-0.30889407129621915, -7.359028120889175],
  [-0.5088948342356723, -8.359028120889175],
  [0.4911051657643277, -8.059028883828628],
  [0.8911047842946012, -7.259029646768081],
  [1.4911051657643277, -6.759029646768081],
  [2.191105928703781, -6.259029646768081],
  [2.2911044028248746, -7.059028883828628],
  [1.6911059287037808, -7.859028120889175],
  [2.891104784294601, -7.759029646768081],
  [3.7911044028248746, -7.959030409707534],
  [4.291104402824875, -7.259029646768081],
  [3.4911051657643277, -7.059028883828628],
  [4.091105547234054, -6.559028883828628],
  [4.691105928703781, -6.659031172646987],
  [4.991105165764328, -7.459030409707534],
  [4.691105928703781, -8.25902964676808],
  [5.691105928703781, -7.859028120889175],
  [5.791104402824875, -7.159031172646987],
  [6.391104784294601, -7.559028883828628],
  [6.391104784294601, -8.25902964676808],
  [5.591105547234054, -8.859028120889175],
  [6.391104784294601, -9.359028120889175],
  [7.0911036398854215, -9.959030409707534],
  [7.991105165764328, -10.25902964676808],
  [7.791104402824875, -9.159031172646987],
  [7.0911036398854215, -8.659031172646987],
  [7.691105928703781, -8.25902964676808],
  [7.0911036398854215, -7.859028120889175],
  [6.991105165764328, -7.059028883828628],
  [6.391104784294601, -6.759029646768081],
  [6.891104784294601, -6.359028120889175],
  [7.491105165764328, -6.159031172646987],
  [8.091103639885421, -6.559028883828628],
  [7.491105165764328, -6.759029646768081],
  [7.791104402824875, -7.359028120889175],
  [8.491105165764328, -7.759029646768081],
  [8.391106691643234, -8.659031172646987],
  [8.491105165764328, -9.459030409707534],
  [8.891106691643234, -10.159031172646987],
  [9.491105165764328, -9.659031172646987],
  [9.791104402824875, -8.859028120889175],
  [9.091103639885421, -9.059028883828628],
  [9.091103639885421, -8.25902964676808],
  [9.69110592870378, -7.859028120889175],
  [9.091103639885421, -7.459030409707534],
  [9.791104402824875, -7.059028883828628],
  [10.19110592870378, -7.559028883828628],
  [10.591103639885421, -7.059028883828628],
  [11.291104402824875, -7.259029646768081],
  [10.891106691643234, -7.759029646768081],
  [10.291104402824875, -8.159031172646987],
  [10.491105165764328, -8.75902964676808],
  [11.19110592870378, -8.459030409707534],
  [11.591103639885421, -7.859028120889175],
  [11.991105165764328, -7.159031172646987],
  [12.591103639885421, -6.959030409707534],
  [13.19110592870378, -6.659031172646987],
  [12.891106691643234, -6.059028883828628],
  [13.491105165764328, -6.159031172646987],
  [13.391106691643234, -5.559028883828628],
  [12.791104402824875, -5.359028120889175],
  [12.19110592870378, -5.259029646768081],
  [11.591103639885421, -5.259029646768081],
  [10.891106691643234, -5.259029646768081],
  [10.19110592870378, -5.059028883828628],
  [10.19110592870378, -5.759029646768081],
  [10.69110592870378, -5.859028120889175],
  [11.291104402824875, -5.859028120889175],
  [11.891106691643234, -5.859028120889175],
  [12.391106691643234, -5.859028120889175],
  [12.291104402824875, -6.459030409707534],
  [11.591103639885421, -6.559028883828628],
  [10.991105165764328, -6.559028883828628],
  [10.19110592870378, -6.459030409707534],
  [9.591103639885421, -6.259029646768081],
  [9.19110592870378, -6.759029646768081],
  [8.491105165764328, -7.059028883828628],
  [8.69110592870378, -6.259029646768081],
  [8.19110592870378, -5.859028120889175],
  [9.091103639885421, -5.759029646768081],
  [9.69110592870378, -5.459030409707534],
  [9.291104402824875, -4.959030409707534],
  [8.591103639885421, -4.759029646768081],
  [8.69110592870378, -5.359028120889175],
  [8.091103639885421, -5.159031172646987],
  [7.891106691643234, -4.559028883828628],
  [7.191105928703781, -4.459030409707534],
  [7.391106691643234, -5.059028883828628],
  [7.5911036398854215, -5.559028883828628],
  [6.891104784294601, -5.659031172646987],
  [6.391104784294601, -6.059028883828628],
  [5.791104402824875, -6.459030409707534],
  [5.291104402824875, -6.759029646768081],
  [4.591105547234054, -6.059028883828628],
  [3.891104784294601, -5.859028120889175],
  [3.391104784294601, -6.259029646768081],
  [2.891104784294601, -6.659031172646987],
  [2.7911044028248746, -5.959030409707534],
  [2.691105928703781, -5.359028120889175],
  [2.5911055472340543, -4.759029646768081],
  [3.191105928703781, -4.959030409707534],
  [3.2911044028248746, -5.659031172646987],
  [3.7911044028248746, -5.259029646768081],
  [4.491105165764328, -5.359028120889175],
  [4.291104402824875, -4.759029646768081],
  [4.791104402824875, -4.359030028237807],
  [4.991105165764328, -4.959030409707534],
  [5.091105547234054, -5.559028883828628],
  [5.191105928703781, -6.159031172646987],
  [5.691105928703781, -5.759029646768081],
  [5.591105547234054, -5.159031172646987],
  [6.291104402824875, -5.359028120889175],
  [6.691105928703781, -4.959030409707534],
  [6.091105547234054, -4.659029265298354],
  [6.591105547234054, -4.259029646768081],
  [6.091105547234054, -4.059028883828628],
  [5.491105165764328, -4.559028883828628],
  [5.191105928703781, -4.059028883828628],
  [5.591105547234054, -3.6590292652983543],
  [5.091105547234054, -3.3590300282378074],
  [4.591105547234054, -3.759029646768081],
  [4.091105547234054, -4.159029265298354],
  [3.691105928703781, -4.559028883828628],
  [3.0911055472340543, -4.359030028237807],
  [3.4911051657643277, -3.8590300282378074],
  [3.9911051657643277, -3.459030409707534],
  [4.491105165764328, -3.0590288838286277],
  [3.9911051657643277, -2.759029646768081],
  [3.4911051657643277, -3.1590292652983543],
  [2.891104784294601, -3.5590288838286277],
  [2.891104784294601, -2.8590300282378074],
  [3.4911051657643277, -2.459030409707534],
  [2.9911051657643277, -2.1590292652983543],
  [2.391104784294601, -2.459030409707534],
  [1.9911051657643277, -2.759029646768081],
  [1.7911044028248746, -2.1590292652983543],
  [2.391104784294601, -1.7590296467680808],
  [1.9911051657643277, -1.0590288838286277],
  [2.5911055472340543, -0.7590296467680808],
  [3.2911044028248746, -0.45903040970753395],
  [3.891104784294601, -0.15902926529835426],
  [4.491105165764328, 0.24097035323191918],
  [4.191105928703781, 1.1409699717621926],
  [5.091105547234054, 0.8409707347016457],
  [5.391104784294601, 1.4409711161713723],
  [4.591105547234054, 1.8409707347016457],
  [3.7911044028248746, 1.9409711161713723],
  [3.391104784294601, 1.3409707347016457],
  [3.4911051657643277, 0.6409699717621926],
  [2.691105928703781, 0.24097035323191918],
  [1.9911051657643277, -0.15902926529835426],
  [1.3911047842946012, 0.24097035323191918],
  [2.0911055472340543, 0.6409699717621926],
  [2.691105928703781, 1.040969590292466],
  [1.9911051657643277, 1.540969590292466],
  [1.4911051657643277, 0.9409711161713723],
  [0.9911051657643277, 1.540969590292466],
  [0.2911044028248746, 1.3409707347016457],
  [0.4911051657643277, 2.040969590292466],
  [1.3911047842946012, 2.240970353231919],
  [1.5911055472340543, 3.040969590292466],
  [1.7911044028248746, 3.740970353231919],
  [1.2911044028248746, 4.140969971762193],
  [0.9911051657643277, 3.540969590292466],
  [0.7911044028248746, 2.8409707347016457],
  [-0.008894834235672278, 2.6409699717621926],
  [-0.4088944527659457, 3.240970353231919],
  [0.19110592870378085, 3.3409707347016457],
  [0.39110478429460116, 4.040969590292466],
  [-0.30889407129621915, 4.040969590292466],
  [-0.9088944527659457, 3.6409699717621926],
  [-1.2088955971751254, 4.240970353231919],
  [-1.5088948342356723, 3.540969590292466],
  [-1.1088952157053988, 2.9409711161713723],
  [-1.4088944527659457, 2.3409707347016457],
  [-0.7088955971751254, 2.4409711161713723],
  [-0.2088955971751254, 1.9409711161713723],
  [-1.0088948342356723, 1.7409703532319192],
  [-1.7088955971751254, 1.6409699717621926],
  [-2.108895215705399, 2.240970353231919],
  [-1.8088940712962192, 2.8409707347016457],
  [-2.2088955971751254, 3.4409711161713723],
  [-1.9088944527659457, 4.140969971762193],
  [-1.7088955971751254, 4.740970353231919],
  [-1.4088944527659457, 5.340970734701646],
  [-0.7088955971751254, 4.740970353231919],
  [-0.7088955971751254, 5.340970734701646],
  [-0.10889521570539884, 5.240970353231919],
  [-0.30889407129621915, 5.940971116171372],
  [-1.1088952157053988, 5.940971116171372],
  [-0.8088940712962192, 6.540969590292466],
  [-0.2088955971751254, 6.640969971762193],
  [0.39110478429460116, 6.440971116171372],
  [0.39110478429460116, 5.840970734701646],
  [0.5911055472340543, 5.140969971762193],
  [-0.008894834235672278, 4.640969971762193],
  [0.6911059287037808, 4.540969590292466],
  [1.3911047842946012, 4.940971116171372],
  [1.1911059287037808, 5.540969590292466],
  [0.9911051657643277, 6.240970353231919],
  [1.4911051657643277, 6.640969971762193],
  [1.8911047842946012, 7.040969590292466],
  [1.2911044028248746, 7.540969590292466],
  [1.5911055472340543, 8.140969971762193],
  [0.8911047842946012, 8.24097035323192],
  [0.5911055472340543, 7.640969971762193],
  [0.8911047842946012, 6.940971116171372],
  [0.19110592870378085, 7.140969971762193],
  [-0.6088952157053988, 7.240970353231919],
  [-0.2088955971751254, 7.840970734701646],
  [0.19110592870378085, 8.340970734701646],
  [0.5911055472340543, 8.840970734701646],
  [1.2911044028248746, 8.74097035323192],
  [1.0911055472340543, 9.440971116171372],
  [0.5911055472340543, 10.440971116171372],
  [-0.008894834235672278, 9.540969590292466],
  [-1.0088948342356723, 9.74097035323192],
  [-1.3088940712962192, 10.640969971762193],
  [-2.108895215705399, 10.640969971762193],
  [-1.6088952157053988, 11.24097035323192],
  [-1.2088955971751254, 11.840970734701646],
  [-0.4088944527659457, 11.840970734701646],
  [-0.8088940712962192, 11.24097035323192],
  [-0.4088944527659457, 10.540969590292466],
  [0.19110592870378085, 11.24097035323192],
  [1.1911059287037808, 11.140969971762193],
  [0.4911051657643277, 12.040970543966782],
  [-0.10889521570539884, 12.440970162497056],
  [-0.8088940712962192, 12.440970162497056],
  [-0.4088944527659457, 13.040970543966782],
  [0.09110554723405428, 13.640969971762193],
  [0.7911044028248746, 13.540970543966782],
  [0.4911051657643277, 12.840970734701646],
  [1.3911047842946012, 13.040970543966782],
  [1.3911047842946012, 13.940970162497056],
  [0.5911055472340543, 14.24097035323192],
  [1.1911059287037808, 14.74097035323192],
  [1.8911047842946012, 14.440970162497056],
  [2.191105928703781, 13.640969971762193],
  [2.191105928703781, 12.74097035323192],
  [2.7911044028248746, 12.140969971762193],
  [1.3911047842946012, 12.140969971762193],
  [2.0911055472340543, 11.540970543966782],
  [2.191105928703781, 10.440971116171372],
  [2.7911044028248746, 10.24097035323192],
  [2.7911044028248746, 10.940971116171372],
  [3.391104784294601, 11.340970734701646],
  [3.4911051657643277, 10.540969590292466],
  [4.091105547234054, 10.040969590292466],
  [3.391104784294601, 9.840970734701646],
  [3.891104784294601, 9.340970734701646],
  [4.491105165764328, 9.440971116171372],
  [4.791104402824875, 10.040969590292466],
  [4.491105165764328, 10.640969971762193],
  [3.9911051657643277, 10.940971116171372],
  [4.091105547234054, 11.540970543966782],
  [4.691105928703781, 11.24097035323192],
  [4.691105928703781, 11.940970162497056],
  [5.291104402824875, 11.640969971762193],
  [6.091105547234054, 11.24097035323192],
  [5.491105165764328, 11.140969971762193],
  [5.191105928703781, 10.540969590292466],
  [5.191105928703781, 9.440971116171372],
  [5.191105928703781, 8.840970734701646],
  [5.691105928703781, 8.340970734701646],
  [6.391104784294601, 8.440971116171372],
  [5.891104784294601, 9.140969971762193],
  [6.691105928703781, 9.24097035323192],
  [6.291104402824875, 9.840970734701646],
  [5.591105547234054, 10.040969590292466],
  [5.891104784294601, 10.540969590292466],
  [6.591105547234054, 10.640969971762193],
  [6.891104784294601, 11.24097035323192],
  [7.5911036398854215, 11.440970162497056],
  [8.291104402824875, 11.640969971762193],
  [8.591103639885421, 12.340970734701646],
  [8.591103639885421, 13.040970543966782],
  [8.291104402824875, 13.640969971762193],
  [7.991105165764328, 12.840970734701646],
  [7.791104402824875, 12.140969971762193],
  [7.0911036398854215, 12.040970543966782],
  [6.491105165764328, 11.74097035323192],
  [5.891104784294601, 11.940970162497056],
  [5.291104402824875, 12.340970734701646],
  [5.891104784294601, 12.640969971762193],
  [6.491105165764328, 12.440970162497056],
  [6.491105165764328, 13.040970543966782],
  [7.191105928703781, 12.74097035323192],
  [7.0911036398854215, 13.440970162497056],
  [7.691105928703781, 13.340970734701646],
  [7.5911036398854215, 14.040970543966782],
  [8.19110592870378, 14.340970734701646],
  [8.891106691643234, 14.140969971762193],
  [9.291104402824875, 13.540970543966782],
  [9.291104402824875, 12.640969971762193],
  [9.291104402824875, 11.840970734701646],
  [9.891106691643234, 11.24097035323192],
  [9.091103639885421, 10.840970734701646],
  [8.69110592870378, 10.24097035323192],
  [9.291104402824875, 9.840970734701646],
  [10.19110592870378, 10.540969590292466],
  [10.291104402824875, 9.640969971762193],
  [10.091103639885421, 8.74097035323192],
  [9.091103639885421, 8.840970734701646],
  [9.591103639885421, 7.940971116171372],
  [8.69110592870378, 7.940971116171372],
  [8.19110592870378, 8.640969971762193],
  [8.491105165764328, 9.440971116171372],
  [7.791104402824875, 10.040969590292466],
  [8.091103639885421, 10.840970734701646],
  [7.391106691643234, 10.640969971762193],
  [6.991105165764328, 9.940971116171372],
  [7.5911036398854215, 9.340970734701646],
  [7.291104402824875, 8.540969590292466],
  [6.991105165764328, 7.740970353231919],
  [6.191105928703781, 7.640969971762193],
  [6.491105165764328, 6.940971116171372],
  [6.191105928703781, 6.140969971762193],
  [7.5911036398854215, 5.440971116171372],
  [7.991105165764328, 6.140969971762193],
  [7.191105928703781, 6.140969971762193],
  [7.391106691643234, 7.040969590292466],
  [7.891106691643234, 7.740970353231919],
  [8.291104402824875, 6.940971116171372],
  [9.091103639885421, 6.940971116171372],
  [9.091103639885421, 5.940971116171372],
  [8.791104402824875, 5.240970353231919],
  [8.291104402824875, 4.540969590292466],
  [7.5911036398854215, 3.9409711161713723],
  [6.991105165764328, 3.3409707347016457],
  [6.191105928703781, 2.8409707347016457],
  [5.491105165764328, 2.240970353231919],
  [4.791104402824875, 3.1409699717621926],
  [5.491105165764328, 3.6409699717621926],
  [6.291104402824875, 4.140969971762193],
  [6.991105165764328, 4.740970353231919],
  [6.691105928703781, 5.540969590292466],
  [5.891104784294601, 5.240970353231919],
  [5.491105165764328, 4.640969971762193],
  [4.891104784294601, 5.140969971762193],
  [5.291104402824875, 5.940971116171372],
  [5.691105928703781, 6.740970353231919],
  [5.391104784294601, 7.540969590292466],
  [4.891104784294601, 8.24097035323192],
  [4.691105928703781, 7.540969590292466],
  [4.791104402824875, 6.740970353231919],
  [4.491105165764328, 6.040969590292466],
  [4.091105547234054, 5.340970734701646],
  [4.091105547234054, 4.640969971762193],
  [4.691105928703781, 4.240970353231919],
  [3.891104784294601, 3.8409707347016457],
  [3.9911051657643277, 2.9409711161713723],
  [3.0911055472340543, 2.6409699717621926],
  [2.7911044028248746, 1.7409703532319192],
  [2.2911044028248746, 2.3409707347016457],
  [2.391104784294601, 3.240970353231919],
  [3.191105928703781, 3.540969590292466],
  [3.2911044028248746, 4.340970734701646],
  [2.5911055472340543, 4.040969590292466],
  [1.9911051657643277, 4.440971116171372],
  [2.5911055472340543, 4.840970734701646],
  [3.2911044028248746, 5.140969971762193],
  [2.691105928703781, 5.740970353231919],
  [1.9911051657643277, 5.240970353231919],
  [1.7911044028248746, 5.940971116171372],
  [2.2911044028248746, 6.440971116171372],
  [3.0911055472340543, 6.440971116171372],
  [3.5911055472340543, 5.840970734701646],
  [3.891104784294601, 6.540969590292466],
  [3.9911051657643277, 7.340970734701646],
  [4.191105928703781, 8.040969590292466],
  [4.391104784294601, 8.74097035323192],
  [3.691105928703781, 8.540969590292466],
  [3.4911051657643277, 7.840970734701646],
  [3.391104784294601, 7.140969971762193],
  [2.691105928703781, 7.040969590292466],
  [2.891104784294601, 7.740970353231919],
  [2.9911051657643277, 8.440971116171372],
  [3.2911044028248746, 9.040969590292466],
  [2.7911044028248746, 9.540969590292466],
  [2.2911044028248746, 9.74097035323192],
  [1.5911055472340543, 10.040969590292466],
  [1.7911044028248746, 9.340970734701646],
  [1.8911047842946012, 8.74097035323192],
  [2.4911051657643277, 9.040969590292466],
  [2.391104784294601, 8.24097035323192],
  [2.0911055472340543, 7.640969971762193],
];
